import React, {PropTypes} from "react";
import Modal from "react-bootstrap/lib/Modal";
import RaisedButton from "material-ui/RaisedButton";
import axios from "axios";

class Modals extends React.Component {

  constructor() {
    super();
    this.state = {reportingManager: null, personal: false, professional: true, employee: {}}

  }

  componentDidMount() {
    axios.get(process.env.REQ_URL + "/personal?q=" + this.props.employee.employeeCode, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {


      this.setState({employee: response.data.data})

    }).catch((error) => {
      console.log(error);
    });

  }


  render() {

    return <Modal
      bsSize="large"
      show={this.props.open} onHide={this.props.close}>
      <Modal.Header closeButton>
        <Modal.Title>
          {this.props.employee.name}&nbsp;&nbsp;&nbsp;
          <RaisedButton
            onClick={()=> {
              if (!this.state.professional) {
                this.setState({professional: true, personal: false});
              }

            }}
            label="Professional Details" secondary={this.state.professional}/>&nbsp;&nbsp;
          <div style={{display: this.props.display}}>
            <RaisedButton
              onClick={()=> {
                if (!this.state.personal)
                  this.setState({professional: false, personal: true})
              }}
              label="Personal Details" secondary={this.state.personal}/></div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>

        {this.state.professional ?
          <div className="col-xs-12">
            <div className="col-xs-6">

              <table className="table table-bordered" cellpadding="0" cellspacing="0" border="0">
                <thead>
                <tr>
                  <th></th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr></tr>
                <tr>
                  <td width={150}>Id:</td>
                  <td>{this.props.employee.employeeCode}</td>
                </tr>
                <tr>
                  <td>Name:</td>
                  <td>{this.props.employee.name} </td>
                </tr>
                <tr>
                  <td>Email Id:</td>
                  <td>{this.props.employee.emailId}</td>
                </tr>
                <tr width={200}>
                  <td width={200}>Department:</td>
                  <td>{this.props.employee.department}</td>
                </tr>

                <tr>
                  <td>Sub Department</td>
                  <td>{this.props.employee.subDepartment}</td>
                </tr>

                <tr>
                  <td>Function:</td>
                  <td>{this.props.employee.function}</td>
                </tr>
                <tr>
                  <td>Status</td>
                  <td>{this.props.employee.empStatus}</td>
                </tr>


                </tbody>
              </table>


            </div>
            <div className="col-xs-6">

              <table className="table table-bordered" cellpadding="0" cellspacing="0" border="0">
                <thead>
                <tr>
                  <th></th>
                  <th></th>
                </tr>
                </thead>
                <tbody>

                <tr>
                  <td>Reporting Manager:</td>
                  <td>
                    {this.props.employee.reportingTo}&nbsp;{this.props.employee.managerName}</td>
                </tr>

                <tr>
                  <td>Date of Joining:</td>
                  <td>{new Date(this.props.employee.dateOfJoining).toDateString()}</td>
                </tr>
                <tr>
                  <td>Designation:</td>
                  <td>{this.props.employee.designation}</td>
                </tr>
                <tr>
                  <td>Vertical:</td>
                  <td>{this.props.employee.vertical}</td>
                </tr>
                <tr>
                  <td>Vertical Head:</td>
                  <td>{this.props.employee.verticalHead}&nbsp;{this.props.employee.verticalHeadName}</td>
                </tr>
                <tr>
                  <td>Office Location:</td>
                  <td>{this.props.employee.location}</td>
                </tr>

                <tr>
                  <td>PayRoll</td>
                  <td>{this.props.employee.payroll}</td>
                </tr>


                </tbody>
              </table>
            </div>


          </div> : null}
        {this.state.personal ? <div className="col-xs-12">
          <div className="col-xs-6">


            <table className="table table-bordered" cellpadding="0" cellspacing="0" border="0">
              <thead>
              <tr>
                <th></th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td width={150}>Id:</td>
                <td>{this.state.employee.empId}</td>
              </tr>
              <tr>
                <td>Name:</td>
                <td>{this.state.employee.name} </td>
              </tr>
              <tr>
                <td>Father Name:</td>
                <td>{this.state.employee.fatherName}</td>
              </tr>
              <tr>
                <td>Mother Name:</td>
                <td>{this.state.employee.motherName}</td>
              </tr>
              <tr>
                <td>Gender</td>
                <td>{this.state.employee.gender}</td>
              </tr>
              <tr>
                <td>Marital Status:</td>
                <td>{this.state.employee.maritalStatus}</td>
              </tr>
              <tr>
                <td>Aniversary:</td>
                <td>{this.state.employee.empAnniversary}</td>
              </tr>
              </tbody>
            </table>


          </div>
          <div className="col-xs-6">

            <table className="table table-bordered" cellpadding="0" cellspacing="0" border="0">
              <thead>
              <tr>
                <th></th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>Date of Birth:</td>
                <td>
                  {this.state.employee.empDOB != null ? new Date(this.state.employee.empDOB).toLocaleDateString('en-GB') : null}</td>
              </tr>
              <tr>
                <td>Personal Email Id:</td>
                <td>
                  {this.state.employee.emailIdPersonal}</td>
              </tr>

              <tr>
                <td>Skype Id:</td>
                <td>{this.state.employee.skypeId}</td>
              </tr>
              <tr width={200}>
                <td width={200}>Address:</td>
                <td>{this.state.employee.address}</td>
              </tr>

              <tr>
                <td>Contact No:</td>
                <td>{this.state.employee.contactNo}</td>
              </tr>
              <tr>
                <td>Emergency No:</td>
                <td>{this.state.employee.emergencyNo}</td>
              </tr>
              <tr>
                <td>Status</td>
                <td>{this.props.employee.empStatus}</td>
              </tr>
              </tbody>
            </table>
          </div>


        </div> : null}
        &nbsp;

      </Modal.Body>
    </Modal>

  }
}

Modals.propTypes = {};

export default Modals;





/** WEBPACK FOOTER **
 ** ./src/feature/hradmin/PeopleSearch/components/ModalView.js
 **/